import { render, staticRenderFns } from "./WCompaniesSearch.vue?vue&type=template&id=5cf192e5&"
import script from "./WCompaniesSearch.vue?vue&type=script&lang=ts&"
export * from "./WCompaniesSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports